// extracted by mini-css-extract-plugin
module.exports = {"donutLabels":"Charts_donutLabels__3H3KI","label":"Charts_label__1P70S"};